import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { MESSAGES } from "endpointsConst";

const initialState = {
    hasNewMessage: false,
    unreadCount: 0,
};

export const getIsNewMessage = createAsyncThunk(
    "newMessages/getIsNewMessage",
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(MESSAGES + "/isSeen");

            return res.data;
        } catch (error) {
            return rejectWithValue(error.response.status);
        }
    },
);

export const newMessageSlice = createSlice({
    name: "newMessage",
    initialState,
    reducers: {
        setNewMessage: (state, action) => {
            state.hasNewMessage = !action.payload.isSeen;
        },
        setUnreadCount: (state, action) => {
            state.unreadCount = action.payload;
        },
    },
    extraReducers: {
        [getIsNewMessage.fulfilled]: (state, action) => {
            state.hasNewMessage = !action.payload.isSeen;
        },
    },
});

export const { setNewMessage, setUnreadCount } = newMessageSlice.actions;

export default newMessageSlice.reducer;
